const municipalityKey = (municipalityCode?: string) => [
    "municipality",
    municipalityCode,
];

const unitKey = (unitId?: string) => ["unit", unitId];
const orderersKey = (orderersKey?: string) => ["orderers", orderersKey];
const administratorsKey = (administratorKey?: string) => [
    "administrators",
    administratorKey,
];
const customersKey = (customersKey?: string) => ["customers", customersKey];

export const queryKeys = {
    customer: {
        full: (municipalityCode: string) => [
            ...municipalityKey(municipalityCode),
            ...customersKey("all"),
        ],
        byId: (id: string | undefined, municipalityCode: string) => [
            ...municipalityKey(municipalityCode),
            ...customersKey(id),
        ],
        all: (
            municipalityCode: string,
            page: number,
            pageSize: number,
            unitIds?: string[],
            searchQuery?: string
        ) => [
            ...municipalityKey(municipalityCode),
            ...customersKey("all"),
            { units: unitIds, page, pageSize, searchQuery },
        ],
    },
    orderer: {
        search: (municipalityCode: string, unitIds?: string[]) => [
            ...municipalityKey(municipalityCode),
            ...orderersKey("all"),
            { units: unitIds },
        ],
        all: (municipalityCode: string) => [
            ...municipalityKey(municipalityCode),
            ...orderersKey("all"),
        ],
        byId: (municipalityCode: string, id?: string) => [
            ...municipalityKey(municipalityCode),
            ...orderersKey(id),
        ],
    },
    administrator: {
        all: (municipalityCode: string) => [
            ...municipalityKey(municipalityCode),
            ...administratorsKey("all"),
        ],
        byId: (municipalityCode: string, id?: string) => [
            ...municipalityKey(municipalityCode),
            ...administratorsKey(id),
        ],
    },
    unit: {
        all: (municipalityCode?: string) => [
            ...municipalityKey(municipalityCode),
            ...unitKey("all"),
        ],
        byId: (municipalityCode?: string, unitId?: string) => [
            ...municipalityKey(municipalityCode),
            ...unitKey(unitId),
        ],
        restrictions: (
            municipalityCode: string | undefined,
            unitId?: string
        ) => [...queryKeys.unit.byId(municipalityCode, unitId), "restrictions"],
        replacements: (
            municipalityCode: string | undefined,
            unitId?: string
        ) => [...queryKeys.unit.byId(municipalityCode, unitId), "replacements"],
    },
    municipality: {
        availablePaymentMethods: (municipalityCode?: string) => [
            ...municipalityKey(municipalityCode),
            "availablePaymentMethods",
        ],
        restrictions: (municipalityCode?: string) => [
            ...municipalityKey(municipalityCode),
            "restrictions",
        ],
        details: (municipalityCode?: string) => [
            ...municipalityKey(municipalityCode),
            "details",
        ],
    },
};
